import PropTypes from "prop-types";
import React from "react";
import { FORM_FIELDS } from "../../constants";

export const FormButtons = ({ navigate }) => (
  <div className="flex w-1/6 justify-between">
    <button
      type="button"
      className="bg-teal-600 text-white text-center py-1 text-lg px-4 font-normal my-3"
      onClick={() => navigate("/")}
    >
      {FORM_FIELDS.BTN_CANCEL}
    </button>
    <button
      type="submit"
      className="bg-sky-800 text-white text-center py-1 text-lg px-4 font-normal my-3"
    >
      {FORM_FIELDS.BTN_SUBMIT}
    </button>
  </div>
);

FormButtons.propTypes = {
  navigate: PropTypes.func.isRequired,
};
